<common-card>
  <common-card-header>
    <h3 *ngIf="!canEditDate">{{'modules.mission.mission_form.datetime_dialog.title' | translate}}</h3>
    <h3 *ngIf="canEditDate">{{'modules.mission.mission_form.datetime_dialog.take_over_time_slot_title' | translate}}</h3>
  </common-card-header>
  <common-card-body>
    <div class="d-flex align-items-center">
      <label class="mb-0 mr-2">{{'modules.mission.mission_form.datetime_dialog.between' | translate}}</label>
      <ng-container *ngIf="canEditDate">
        <input [nbDatepicker]="afterDatepicker"
               nbInput
               readonly
               class="mr-2"
               [(ngModel)]="afterDate">
        <nb-datepicker #afterDatepicker
                       [format]="'DD.MM.YYYY'">
        </nb-datepicker>
      </ng-container>
      <input nbInput type="time" class="mr-2" [(ngModel)]="afterTime">

      <label class="mb-0 mr-2">{{'modules.mission.mission_form.datetime_dialog.and' | translate}}</label>
      <ng-container *ngIf="canEditDate">
        <input [nbDatepicker]="beforeDatepicker"
               nbInput
               readonly
               class="mr-2"
               [(ngModel)]="beforeDate">
        <nb-datepicker #beforeDatepicker
                       [format]="'DD.MM.YYYY'">
        </nb-datepicker>
      </ng-container>
      <input nbInput type="time" class="mr-2" [(ngModel)]="beforeTime">
    </div>
  </common-card-body>
  <common-card-footer>
    <div class="row">
      <div class="col-12 text-right">
        <button nbButton status="primary" (click)="submit()">
          {{'global.button.submit' | translate}}
        </button>
      </div>
    </div>
  </common-card-footer>
</common-card>
